import { PRODUCTS, FarewillProduct } from 'utils/enums'

/** Products that do not support partner assignment will have the partner selection UI hidden. */
export const productsWithoutPartners: FarewillProduct[] = [
  PRODUCTS.FUNERAL_PLAN,
  PRODUCTS.FUNERAL,
]
